import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "end-of-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_lottie_animation = _resolveComponent("lottie-animation")!

  return (_openBlock(), _createElementBlock("view", _hoisted_1, [
    _createVNode(_component_ion_card_subtitle, { class: "ion-padding ion-text-center" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.message || _ctx.defaultMessage), 1)
      ]),
      _: 1
    }),
    _createElementVNode("view", {
      class: "display-flex ion-justify-content-center ion-padding-bottom",
      style: _normalizeStyle(_ctx.inlineStyle)
    }, [
      _createVNode(_component_lottie_animation, {
        class: "end-of-list-animation",
        "animation-data": _ctx.reachedTheEndAnimation,
        loop: true
      }, {
        fallback: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.faListCheck,
            class: "firecracker-primary-color-icon-large"
          }, null, 8, ["icon"])
        ]),
        _: 1
      }, 8, ["animation-data"])
    ], 4)
  ]))
}